class LystivkaMenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-button]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.panel.hidden) this.close();
    });
  }

  toggle() {
    if (this.panel.hidden) this.open(); else this.close();
  }

  open() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
    this.panel.querySelector('a')?.focus();
  }

  close() {
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
    this.button.focus();
  }
}

class ProductGallery extends HTMLElement {
  connectedCallback() {
    const buttons = this.querySelectorAll('[data-gallery-button]');
    const images = this.querySelectorAll('[data-gallery-image]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      images.forEach((image) => { image.hidden = image.dataset.galleryImage !== button.dataset.galleryButton; });
      buttons.forEach((item) => item.setAttribute('aria-current', String(item === button)));
    }));
  }
}

class PackPicker extends HTMLElement {
  connectedCallback() {
    this.quantity = this.closest('form')?.querySelector('[data-pack-quantity]');
    if (!this.quantity) return;
    this.addEventListener('change', (event) => {
      if (!event.target.matches('input[type="radio"]')) return;
      this.quantity.value = event.target.value;
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.quantity.addEventListener('input', () => {
      const matching = this.querySelector(`input[value="${this.quantity.value}"]`);
      this.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = input === matching; });
    });
  }
}

customElements.define('lystivka-menu', LystivkaMenu);
customElements.define('product-gallery', ProductGallery);
customElements.define('pack-picker', PackPicker);
